/* @flow */
import Collection from 'lib/Collection';
import Activity from 'entities/Activity';
import apiRequest from 'lib/apiRequest';

class Activities extends Collection {
  initialize() {
    this.model = Activity;
    this.comparator = (a, b) => b.getCreatedAt() - a.getCreatedAt();
  }

  static loadReceived(): Promise<Activities> {
    return apiRequest('/activities/received', 'GET').then(
      activities => Activities.fromJSON(activities)
    );
  }

  static load(): Promise<Activities> {
    return apiRequest('/activities', 'GET').then(
      response => Activities.fromJSON(response.activities)
    );
  }
}

export default Activities;



// WEBPACK FOOTER //
// ./src/collections/Activities.js